<div class="ap-margin-bottom-3">{{ 'income.date-of-birth.title' | apContent }}</div>
<ap-date-input
    id="mainDateOfBirth"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [formControl]="mainApplicantControl"
    [startAt]="mainApplicantControl?.value ? mainApplicantControl?.value : maxDate"
    [helpText]="'income.date-of-birth.help-text' | apContent"
    [label]="'income.date-of-birth.label' | apContent"
    startView="multi-year"
>
</ap-date-input>

@if (store.hasCoApplicant) {
    <div class="ap-margin-bottom-3">{{ 'income.date-of-birth.co-applicant.title' | apContent }}</div>
    <ap-date-input
        id="coDateOfBirth"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [helpText]="'income.date-of-birth.help-text' | apContent"
        [formControl]="coApplicantControl"
        [startAt]="coApplicantControl?.value ? coApplicantControl?.value : maxDate"
        [label]="'income.date-of-birth.co-applicant.label' | apContent"
        startView="multi-year"
    >
    </ap-date-input>
}

<additional-info
    [key]="questionKey"
    id="hintDateOfBirth"
    [titleKey]="'income.date-of-birth.additional-info.title' | coApplicantPipe: hasCoApplicant"
    [contentKey]="'income.date-of-birth.additional-info.content' | coApplicantPipe: hasCoApplicant"
    [modalUrlKey]="'income.date-of-birth.additional-info.title' | coApplicantPipe: hasCoApplicant"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()" [isLoading]="this.store.isLoading"></next-button>
}
